import React, { createContext, useContext, useState } from 'react';
import { SUB_PANEL_VIEWS } from 'Monitoring/subPanels/tags/constants';
import { LocalStorageKeys } from 'Utils/localStorage';
// -- sub panel view persist
const setStoredSubPanelView = (view) => {
    localStorage.setItem(LocalStorageKeys.TAGS_SUB_PANEL_VIEW, view);
};
const getStoredSubPanelView = () => localStorage.getItem(LocalStorageKeys.TAGS_SUB_PANEL_VIEW);
// Context
const TagsPanelViewContext = createContext(null);
// Provider Component
const TagsPanelViewProvider = ({ children }) => {
    const [tagsPanelView, setTagsPanelView] = useState(getStoredSubPanelView() || SUB_PANEL_VIEWS.TAGS);
    // Handlers
    const handleSetTagsPanelView = (view) => {
        setTagsPanelView(view);
        setStoredSubPanelView(view);
    };
    // Render
    return (React.createElement(TagsPanelViewContext.Provider, { value: {
            tagsPanelView,
            onSetTagsPanelView: handleSetTagsPanelView
        } }, children));
};
// Custom Hook
export const useTagsPanelView = () => useContext(TagsPanelViewContext);
export default TagsPanelViewProvider;
